import React from 'react';
import Icon from 'components/general/Icon/Icon';

const Download: React.SFC<DownloadProps> = ({
  file,
  label,
}) => (
  <a
    className="download"
    href={file.path}
    target="_blank"
    rel="noopener"
    download
  >
    <div className="download__main">
      <Icon
        name="file"
        className="download__icon"
        types={['no-pull', 'lg']}
      />
      <div className="download__body">
        <span className="download__label">
          {label}
        </span>
        <span className="download__filename">
          {file.filename}
        </span>
      </div>
    </div>
    <div className="download__action">
      <Icon
        name="download-cloud"
        types={['no-pull', 'lg']}
      />
      <span className="download__file-size">
        {file.size}
      </span>
    </div>
  </a>
);

export interface DownloadProps {
  file: {
    path: string;
    kind: string;
    size: string;
    filename: string;
  };
  label: string;
}

export default Download;

